
define('app/dashboard/leagues/instances/lgInstanceApp',[
	'jquery',
	'underscore',
	'backbone',
	'known/knownUtil',
	'app/board/collections/pickCollection',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/productModel',
	'known/collections/productCollection',
	'app/dashboard/leagues/instances/views/lgInstanceView',
	'module'
], function(
		$, 
		_, 
		Backbone,
		KnownUtil,
		PickCollection,
		UserModel,
		LeagueInstanceModel,
		ProductModel,
		ProductCollection,
		LgInstanceView, 
		module){
	var initialize = function(){
		var initialModels = KnownUtil.setupSideNav();
		var userModel = initialModels.userModel;
		var prodCollection = initialModels.prodCollection;
		
		var requestedLgInstJSON = $.parseJSON(module.config().requestedLgInstJSON);
		var requestedProdJSON = $.parseJSON(module.config().requestedProdJSON);
		var requestedProdConfigJSON = $.parseJSON(module.config().requestedProdConfigJSON);
		
		var lgInstanceModel = LeagueInstanceModel.findOrCreate(requestedLgInstJSON);
		
		var prodModel = prodCollection.retrieveProdWithProdTypeId(requestedProdJSON.productTypes[0].id);
		if(!prodModel){
			prodModel = ProductModel.findOrCreate(requestedProdJSON);
		}		
		
		var unescapedPicks = $("<div>"+module.config().requestedPicksJSON+"</div>").html();
		var pickCollection = new PickCollection($.parseJSON(unescapedPicks), {
			leagueInstanceId: lgInstanceModel.get('id'), 
			leagueId: lgInstanceModel.get('leagueId')});
		
		var lgInstanceView = new LgInstanceView({
			userModel: userModel, 
			lgInstance: lgInstanceModel, 
			prodModel: prodModel,
			prodConfig: requestedProdConfigJSON,
			pickCollection: pickCollection});
		lgInstanceView.render();
	};
	
	return {
		initialize: initialize
	};
});